module.exports = __webpack_public_path__ + "img/oficina-cuenca.c2cb7555.jpeg";